<div [ngClass]="accountService.otherAccountSettings().dashboardTheme.name" (click)="setFocus($event)">
  <app-tool-bar
    [showWelcomeDialog]="showWelcomeDialog()"
    (applySearchFilter)="applySearchFilter($event)"
    (showAccountSettings)="showAccountSettingsDialog()"
    (logoutAccount)="logout()"
    (saveItem)="navBarSaveButtonAction()"
    (handleAfterCloseWelcomeDialog)="handleAfterCloseWelcomeDialog()"
    [navBarSaveButton]="navBarSaveButton"
  >
  </app-tool-bar>

  <div
    [ngClass]="accountService.otherAccountSettings().dashboardTheme.dashboardContentClass"
    class="dashboard-content"
  >
    @if(accountService.otherAccountSettings().dashboardTheme.name === THEME_NAMES.NIGHT_SKY) {
    <img
      class="night-sky-background"
      src="/assets/night_background.jpg"
      alt="night_background.jpg"
    />
    }
    <router-outlet></router-outlet>
  </div>
</div>
